import { createTheme } from '@idev/ui';

export const theme = createTheme({
    typography: {
        "fontFamily": `"Kanit"`,
        "fontSize": 13,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500
    }
})

export default theme